import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AdminPanel.css";

function AdminPanel() {
  const [admissions, setAdmissions] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetchAdmissions();
  }, []);

  const fetchAdmissions = () => {
    const token = localStorage.getItem("token");
    if (!token) return (window.location.href = "/AdminLogin");

    axios
      .get("http://localhost:5000/admin/submissions",
       {
        headers: { Authorization: token },
      }
    )
      .then((res) => setAdmissions(res.data))
      .catch(() => {
        localStorage.removeItem("token");
        window.location.href = "/AdminLogin";
      });
  };

  // 🆕 Delete handler
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this admission?")) {
      const token = localStorage.getItem("token");
      axios
        .delete(`http://localhost:5000/admin/delete/${id}`, {
          headers: { Authorization: token },
        })
        .then(() => {
          setAdmissions((prev) => prev.filter((ad) => ad._id !== id));
          if (selected && selected._id === id) {
            setSelected(null);
          }
        })
        .catch((err) => alert("Delete failed. Please try again."));
    }
  };

  const exportToCSV = () => {
    if (admissions.length === 0) return;
    const headers = Object.keys(admissions[0]).filter(
      (key) => key !== "_id" && key !== "__v" && key !== "files"
    );
    const rows = admissions.map((ad) =>
      headers.map((key) => `"${ad[key] || ""}"`).join(",")
    );

    const csvContent = [headers.join(","), ...rows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "admissions.csv";
    a.click();
  };

  const renderFile = (label, filename) => {
    if (!filename) return null;
    const url = `http://localhost:5000/uploads/${filename}`;
    return (
      <div>
        <strong>{label}:</strong>
        <br />
        <a href={url} target="_blank" rel="noopener noreferrer">
          <img
            src={url}
            alt={label}
            width="150"
            height="auto"
            style={{ margin: "10px 0" }}
          />
        </a>
      </div>
    );
  };

  return (
    <div className="admin-container">
      <h2>Admin Panel – Admission Data</h2>
      {admissions.length === 0 ? (
        <p>Loading...</p>
      ) : (
        <>
          <button onClick={exportToCSV} className="download-btn">
            Download CSV
          </button>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Student Name</th>
                  <th>Mobile</th>
                  <th>Course</th>
                  <th>Branch</th>
                  <th>Email</th>
                  <th>Details</th>
                  <th>Action</th> {/* 🆕 Added Action column */}
                </tr>
              </thead>
              <tbody>
                {admissions.map((admission) => (
                  <tr key={admission._id}>
                    <td>{admission.studentName}</td>
                    <td>{admission.mobile}</td>
                    <td>{admission.course}</td>
                    <td>{admission.branch}</td>
                    <td>{admission.email}</td>
                    <td>
                      <button onClick={() => setSelected(admission)}>
                        View
                      </button>
                    </td>
                    <td>
                      {/* 🆕 Delete button */}
                      <button
                        onClick={() => handleDelete(admission._id)}
                        className="delete-btn"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {selected && (
            <div className="modal">
              <div className="modal-content">
                <h3>Student Full Details</h3>
                <button className="close-btn" onClick={() => setSelected(null)}>
                  Close
                </button>
                <ul>
                  {Object.entries(selected).map(([key, value]) => {
                    if (["_id", "__v", "files"].includes(key)) return null;
                    return (
                      <li key={key}>
                        <strong>{key}:</strong> {value}
                      </li>
                    );
                  })}
                </ul>

                {selected.files && (
                  <div className="file-previews">
                    {renderFile("Photo", selected.files.photo)}
                    {renderFile("10th Marksheet", selected.files.tenthMarksheet)}
                    {renderFile("12th Marksheet", selected.files.twelfthMarksheet)}
                    {renderFile("Aadhar Front", selected.files.aadharFront)}
                    {renderFile("Aadhar Back", selected.files.aadharBack)}
                    {renderFile("Payment Screenshot", selected.files.paymentScreenshot)}
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default AdminPanel;
